export interface PawcoProduct {
  name: string;
  url: string;
  patterns: RegExp[];
}

export const PAWCO_PRODUCTS: PawcoProduct[] = [
  // ── Main meals ─────────────────────────────────────────────────────────────
  {
    name: 'LuxBites',
    url: 'https://www.mypawco.com/products/luxbites',
    patterns: [/\bLuxBites\b/i],
  },
  {
    name: 'InstaBites',
    url: 'https://www.mypawco.com/products/instabites',
    patterns: [/\bInstaBites\b/i],
  },
  // GreenBites — specific flavors first, then generic fallback
  {
    name: 'GreenBites Blueberry',
    url: 'https://www.mypawco.com/products/greenbites-blueberries-and-veggies',
    patterns: [/\bGreenBites\s*(?:–\s*)?Blueberr/i, /\bBlueberr\w+\s*(?:&|and|&amp;)?\s*Veggies\b/i],
  },
  {
    name: 'GreenBites Mixed Veggies',
    url: 'https://www.mypawco.com/products/greenbites-peas-and-carrots',
    patterns: [/\bGreenBites\s*(?:–\s*)?(?:Mixed\s*Veggies?|Green\s*Mix|Peas?\s*(?:&|and)\s*Carrots?)\b/i],
  },
  {
    name: 'GreenBites PB & Apple',
    url: 'https://www.mypawco.com/products/greenbites-peanut-butter-and-apple',
    patterns: [/\bGreenBites\s*(?:–\s*)?(?:PB|Peanut\s*Butter)\b/i, /\bPeanut\s*[Bb]utter\s*(?:&|and)\s*Apple\b/i],
  },
  {
    name: 'GreenBites Pumpkin',
    url: 'https://www.mypawco.com/products/greenbites-pumpkin-cranberries',
    patterns: [/\bGreenBites\s*(?:–\s*)?Pumpkin\b/i, /\bPumpkin\s*(?:&|and)\s*Cranberr/i],
  },
  {
    name: 'GreenBites',
    url: 'https://www.mypawco.com/products/greenbites-peas-and-carrots',
    patterns: [/\bGreenBites\b/i],
  },
  // ── Toppers ────────────────────────────────────────────────────────────────
  {
    name: 'Magic Topper Gut Health',
    url: 'https://www.mypawco.com/products/magic-topper-plus-gut-health',
    patterns: [/\bMagic\s*Topper\s*(?:–\s*)?Gut\s*Health\b/i, /\bGut\s*Health\s*Topper\b/i],
  },
  {
    name: 'Magic Topper Heart Health',
    url: 'https://www.mypawco.com/products/magic-topper-plus-heart-health',
    patterns: [/\bMagic\s*Topper\s*(?:–\s*)?Heart\s*Health\b/i, /\bHeart\s*Health\s*Topper\b/i],
  },
  {
    name: 'Magic Topper Hip & Joint',
    url: 'https://www.mypawco.com/products/magic-topper-plus-hip-joint',
    patterns: [/\bMagic\s*Topper\s*(?:–\s*)?Hip\s*(?:&|and)\s*Joint\b/i, /\bHip\s*(?:&|and)\s*Joint\s*Topper\b/i],
  },
  {
    name: 'Magic Topper Skin & Coat',
    url: 'https://www.mypawco.com/products/magic-topper-plus-skin-coat',
    patterns: [/\bMagic\s*Topper\s*(?:–\s*)?Skin\s*(?:&|and)\s*Coat\b/i, /\bSkin\s*(?:&|and)\s*Coat\s*Topper\b/i],
  },
  {
    name: 'Magic Topper',
    url: 'https://www.mypawco.com/products/magic-topper-original',
    patterns: [/\bMagic\s*Topper\b/i],
  },
  // ── Magic Bars ─────────────────────────────────────────────────────────────
  {
    name: 'Magic Bar Gut Health',
    url: 'https://www.mypawco.com/products/pawco-foods-magic-bar-plus-gut-health',
    patterns: [/\bMagic\s*Bar\s*(?:Plus\s*)?(?:–\s*)?Gut\s*Health\b/i],
  },
  {
    name: 'Magic Bar Heart Health',
    url: 'https://www.mypawco.com/products/pawco-foods-magic-bar-plus-heart-health',
    patterns: [/\bMagic\s*Bar\s*(?:Plus\s*)?(?:–\s*)?Heart\s*Health\b/i],
  },
  {
    name: 'Magic Bar Hip & Joint',
    url: 'https://www.mypawco.com/products/pawco-foods-magic-bar-plus-hip-joint',
    patterns: [/\bMagic\s*Bar\s*(?:Plus\s*)?(?:–\s*)?Hip\s*(?:&|and)\s*Joint\b/i],
  },
  {
    name: 'Magic Bar Skin & Coat',
    url: 'https://www.mypawco.com/products/pawco-foods-magic-bar-plus-skin-coat',
    patterns: [/\bMagic\s*Bar\s*(?:Plus\s*)?(?:–\s*)?Skin\s*(?:&|and)\s*Coat\b/i],
  },
  {
    name: 'Magic Bar',
    url: 'https://www.mypawco.com/products/pawco-foods-magic-bar-original',
    patterns: [/\bMagic\s*Bars?\b/i],
  },
  // ── Magic Cookies ──────────────────────────────────────────────────────────
  {
    name: 'Magic Cookie Gut Health',
    url: 'https://www.mypawco.com/products/magic-cookies-plus-gut-health',
    patterns: [/\bMagic\s*Cookies?\s*(?:–\s*)?Gut\s*Health\b/i],
  },
  {
    name: 'Magic Cookie Heart Health',
    url: 'https://www.mypawco.com/products/magic-cookies-plus-heart-health',
    patterns: [/\bMagic\s*Cookies?\s*(?:–\s*)?Heart\s*Health\b/i],
  },
  {
    name: 'Magic Cookie Hip & Joint',
    url: 'https://www.mypawco.com/products/magic-cookies-plus-hip-joint',
    patterns: [/\bMagic\s*Cookies?\s*(?:–\s*)?Hip\s*(?:&|and)\s*Joint\b/i],
  },
  {
    name: 'Magic Cookie Skin & Coat',
    url: 'https://www.mypawco.com/products/magic-cookies-plus-skin-coat',
    patterns: [/\bMagic\s*Cookies?\s*(?:–\s*)?Skin\s*(?:&|and)\s*Coat\b/i],
  },
  {
    name: 'Magic Cookie',
    url: 'https://www.mypawco.com/products/magic-cookies-original',
    patterns: [/\bMagic\s*Cookies?\b/i],
  },
];

/** Scan a message and return all unique Pawco products mentioned in it. */
export function detectMentionedProducts(text: string): PawcoProduct[] {
  const found: PawcoProduct[] = [];
  const seenUrls = new Set<string>();

  for (const product of PAWCO_PRODUCTS) {
    if (seenUrls.has(product.url)) continue;
    const mentioned = product.patterns.some(pattern => pattern.test(text));
    if (mentioned) {
      found.push(product);
      seenUrls.add(product.url);
    }
  }

  return found;
}
